module.exports = {
    controller: aboutTheHtsPageController,
    templateUrl: 'us/components/about-the-hts-page.html',
};

aboutTheHtsPageController.$inject = [
    '$analytics',
    '$location',
    'notificationsService'
];

function aboutTheHtsPageController(
    $analytics,
    $location,
    notifications
) {
    var vm = {
        $onInit: attached,
        $onDestroy: detached,
    };
    return vm;

    function attached() {
        $analytics.pageTrack('/about-the-hts');
        notifications.subscribe('filter_movement_changed', movementChanged)
    }

    function detached() {
        notifications.unsubscribe('filter_movement_changed', movementChanged);
    }

    function movementChanged(movement) {
        if (movement === 'export') {
            $location.path('/schedule-b-general-notes');
        }
    }
}